import { Injectable } from '@angular/core';
import { RequestService } from '../request.service';

@Injectable()
export class SpecialtyProviderConfigService {

  constructor(protected requestService: RequestService) { }

  getByProvider(id): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'specialtyProviderConfigByProvider',
      urlParams: {
        id: id
      }
    })
    .then((response: any) => response.json() as any);
  };

  getOne(id): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'specialtyProviderConfig',
      urlParams: {
        id: id
      }
    })
    .then((response: any) => response.json() as any);
  };

  getByProviderAndSpecialty(providerId, specialtyId): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'specialtyProviderConfigBySpecialty',
      urlParams: {
        providerId: providerId,
        specialtyId: specialtyId
      }
    })
    .then((response: any) => response.json() as any);
  };

  create(body): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'specialtyProviderConfigs',
      method: 'post',
      body: JSON.stringify(body)
    });
  }

  update(id,body): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'specialtyProviderConfig',
      urlParams: {
        id: id
      },
      method: 'put',
      body: JSON.stringify(body)
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/specialtyProviderConfig/specialty-provider-config.service.ts